import { render, staticRenderFns } from "./NewDiscountReason.vue?vue&type=template&id=87b40428&scoped=true"
import script from "./NewDiscountReason.vue?vue&type=script&lang=js"
export * from "./NewDiscountReason.vue?vue&type=script&lang=js"
import style0 from "./NewDiscountReason.vue?vue&type=style&index=0&id=87b40428&prod&lang=scss&scoped=true"
import style1 from "./NewDiscountReason.vue?vue&type=style&index=1&id=87b40428&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b40428",
  null
  
)

export default component.exports